t = require('app/scripts/views/internal/teacup-with-helpers')('archive_item')

module.exports = t.renderable ({
  url,
  name,
  orgName,
  deleting,
  canReopen,
  reOpenText,
  canDelete,
  canLeave,
  reopenDisabled
}) ->
  t.div '.item-name', ->
    if url && !deleting
      t.a { href: url }, ->
        t.text name
      t.div '.quiet', ->
    else
      t.span ->
        t.text name

    if orgName
      t.div '.quiet', ->
        t.text orgName

  if deleting
    t.div '.options.quiet', ->
      t.format 'deleting'
  else
    t.div '.options', ->
      if canReopen
        t.a ".button-link.js-reopen#{ if reopenDisabled then '.disabled' else '' }", { href: '#' }, ->
          t.icon 'refresh'
          t.text ' '
          t.text reOpenText
      if canDelete
        t.a '.button-link.negate.js-delete', { href: '#' }, ->
          t.icon 'remove', 'delete'
      if canLeave
        t.a '.button-link.negate.js-leave', { href: '#' }, ->
          t.icon 'leave-board', 'leave'
